export default __webpack_public_path__ + "05a431c2f46eb55941bd3c60e8aa1f6a.svg";